/**
 * 
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ============================================================
// CONTROLE DE LIMITE TOTAL DO CARRINHO (30 ITENS E 20KG)
// ============================================================
const CART_MAX_TOTAL_QUANTITY = 30;
const CART_MAX_TOTAL_WEIGHT = 25000; // 25kg em gramas

// Função para obter dados do carrinho (síncrona)
function getCartDataSync() {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', false); // Síncrono
    xhr.send(null);
    if (xhr.status === 200) {
      return JSON.parse(xhr.responseText);
    }
  } catch (error) {
    console.error('Erro ao obter carrinho:', error);
  }
  return { item_count: 0, total_weight: 0 };
}

// Função para obter a quantidade total atual do carrinho (síncrona para evitar problemas)
function getCartTotalQuantitySync() {
  return getCartDataSync().item_count || 0;
}

// Função para obter o peso total atual do carrinho em gramas (síncrona)
function getCartTotalWeightSync() {
  return getCartDataSync().total_weight || 0;
}

// Função para obter o peso do produto a ser adicionado
function getProductWeightFromForm(form) {
  // Tenta obter o peso do variant selecionado via data attribute
  const variantInput = form.querySelector('[name="id"]');
  if (variantInput) {
    let weight = null;
    if (variantInput.tagName === 'SELECT') {
      weight = variantInput.options[variantInput.selectedIndex]?.getAttribute('data-variant-weight');
    } else {
      weight = variantInput.getAttribute('data-variant-weight');
    }

    if (weight) {
      return parseFloat(weight) || 0;
    }
  }

  // Fallback: tenta obter do JSON do produto na página
  const productJson = document.querySelector('[data-product-json]');
  if (productJson) {
    try {
      const product = JSON.parse(productJson.textContent);
      const selectedVariantId = form.querySelector('[name="id"]')?.value;
      if (selectedVariantId && product.variants) {
        const variant = product.variants.find(v => v.id == selectedVariantId);
        if (variant) {
          return variant.weight || 0;
        }
      }
      // Se não encontrar variante específica, usa o peso do primeiro variante
      if (product.variants && product.variants.length > 0) {
        return product.variants[0].weight || 0;
      }
    } catch (e) {
      console.error('Erro ao parsear JSON do produto:', e);
    }
  }

  return 0;
}

// Função para mostrar mensagem de erro no carrinho (quantidade)
function showCartLimitError(targetElement) {
  console.log('[DEBUG showCartLimitError] Iniciando...', targetElement);

  // Busca o elemento de erro pré-existente
  let errorMessage = null;

  if (targetElement) {
    const form = targetElement.closest('form');
    if (form) {
      errorMessage = form.querySelector('.cart-limit-error-message');
      console.log('[DEBUG showCartLimitError] Buscou no form:', errorMessage);
    }
  }

  // Fallback: busca qualquer elemento de erro na página
  if (!errorMessage) {
    errorMessage = document.querySelector('.cart-limit-error-message');
    console.log('[DEBUG showCartLimitError] Fallback search:', errorMessage);
  }

  if (errorMessage) {
    // Atualiza o contador de itens na mensagem
    const cartData = getCartDataSync();
    const countElement = errorMessage.querySelector('.cart-limit-count');
    if (countElement && cartData.item_count) {
      countElement.textContent = cartData.item_count;
      console.log('[DEBUG showCartLimitError] Contador atualizado para:', cartData.item_count);
    }

    errorMessage.style.display = 'block';
    errorMessage.style.visibility = 'visible';
    errorMessage.style.opacity = '1';
    console.log('[DEBUG showCartLimitError] Mensagem exibida:', errorMessage);

    // Esconde a mensagem após 5 segundos
    setTimeout(() => {
      errorMessage.style.display = 'none';
    }, 5000);
  } else {
    console.error('[DEBUG showCartLimitError] Elemento não encontrado!');
  }
}

// Função para mostrar mensagem de erro de peso
function showCartWeightError(targetElement, remainingWeight = 0, isCartEmpty = false, weightToAdd = 0) {
  // Busca o elemento de erro de peso pré-existente
  let errorMessage = null;

  if (targetElement) {
    const form = targetElement.closest('form');
    if (form) {
      errorMessage = form.querySelector('.cart-weight-error-message');
    }
  }

  // Fallback: busca qualquer elemento de erro de peso na página
  if (!errorMessage) {
    errorMessage = document.querySelector('.cart-weight-error-message');
  }

  // Se não existir elemento específico de peso, usa o de limite
  if (!errorMessage) {
    showCartLimitError(targetElement);
    return;
  }

  if (errorMessage) {
    if (isCartEmpty) {
      const weightToAddKg = (weightToAdd / 1000).toFixed(2).replace('.', ',');
      errorMessage.innerHTML = `O limite é 25kg e você adicionou ${weightToAddKg}kg`;
    } else {
      // Caso 2: Carrinho já tem itens e a nova adição excede o limite
      const weightKg = (remainingWeight / 1000).toFixed(2).replace('.', ',');
      errorMessage.innerHTML = `O limite é 25kg, você pode adicionar mais ${weightKg}kg`;
    }

    errorMessage.style.display = 'block';

    // Esconde a mensagem após 5 segundos
    setTimeout(() => {
      errorMessage.style.display = 'none';
    }, 5000);
  }
}

// Intercepta apenas os cliques nos botões de adicionar ao carrinho
document.addEventListener('click', function (e) {
  const addToCartButton = e.target.closest('[data-action="add-to-cart"], [type="submit"][name="add"], .product-form__add-button, .add-to-cart-button');

  if (!addToCartButton) return;

  // IGNORA o botão "Comprar Agora" - ele tem sua própria validação
  if (addToCartButton.hasAttribute('data-buy-now-button') || addToCartButton.closest('[data-buy-now-button]')) return;

  const form = addToCartButton.closest('form[action*="/cart/add"]');
  if (!form) return;

  // Obtém a quantidade a ser adicionada
  const quantityInput = form.querySelector('[name="quantity"]');
  const quantityToAdd = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

  // Obtém dados atuais do carrinho
  const cartData = getCartDataSync();
  const currentTotal = cartData.item_count || 0;
  const currentWeight = cartData.total_weight || 0;

  // Verifica limite de quantidade
  if ((currentTotal + quantityToAdd) > CART_MAX_TOTAL_QUANTITY) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    showCartLimitError(addToCartButton);
    return false;
  }

  // Verifica limite de peso
  const productWeight = getProductWeightFromForm(form);
  const weightToAdd = productWeight * quantityToAdd;

  if ((currentWeight + weightToAdd) > CART_MAX_TOTAL_WEIGHT) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const remainingWeight = Math.max(0, CART_MAX_TOTAL_WEIGHT - currentWeight);
    const isCartEmpty = currentWeight === 0;
    showCartWeightError(addToCartButton, remainingWeight, isCartEmpty, weightToAdd);
    return false;
  }
}, true);


// ============================================================
// SISTEMA DE BACKUP E RESTAURAÇÃO DO CARRINHO PARA "COMPRAR AGORA"
// ============================================================

// Função para salvar o carrinho atual no localStorage
function saveCartToLocalStorage() {
  return new Promise(function (resolve, reject) {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cart.items && cart.items.length > 0) {
          // Salva os itens do carrinho formatados para restauração
          var cartBackup = cart.items.map(function (item) {
            return {
              id: item.variant_id,
              quantity: item.quantity,
              properties: item.properties || {}
            };
          });
          localStorage.setItem('cartBackup', JSON.stringify(cartBackup));
          localStorage.setItem('cartBackupTimestamp', Date.now().toString());
          console.log('[BuyNow] Carrinho salvo:', cartBackup.length, 'itens');
        }
        resolve();
      })
      .catch(function (error) {
        console.error('[BuyNow] Erro ao salvar carrinho:', error);
        resolve(); // Continua mesmo com erro
      });
  });
}

// Função para restaurar o carrinho do localStorage
function restoreCartFromLocalStorage() {
  var cartBackup = localStorage.getItem('cartBackup');
  var timestamp = localStorage.getItem('cartBackupTimestamp');

  // Só restaura se o backup existir e tiver menos de 24 horas
  if (!cartBackup || !timestamp) return;

  var backupAge = Date.now() - parseInt(timestamp);
  var maxAge = 24 * 60 * 60 * 1000; // 24 horas

  if (backupAge > maxAge) {
    localStorage.removeItem('cartBackup');
    localStorage.removeItem('cartBackupTimestamp');
    return;
  }

  try {
    var items = JSON.parse(cartBackup);
    if (!items || items.length === 0) return;

    console.log('[BuyNow] Restaurando carrinho:', items.length, 'itens');

    // Prepara os itens para adicionar
    var addItems = items.map(function (item) {
      return {
        id: item.id,
        quantity: item.quantity,
        properties: item.properties
      };
    });

    // PRIMEIRO: Limpa o carrinho atual (para remover o produto do checkout)
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function () {
        console.log('[BuyNow] Carrinho limpo, adicionando itens do backup...');

        // DEPOIS: Adiciona os itens do backup
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addItems })
        });
      })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        console.log('[BuyNow] Carrinho restaurado com sucesso');
        // Limpa o backup após restaurar
        localStorage.removeItem('cartBackup');
        localStorage.removeItem('cartBackupTimestamp');

        // Recarrega a página para atualizar o contador e o mini-cart
        window.location.reload();
      })
      .catch(function (error) {
        console.error('[BuyNow] Erro ao restaurar carrinho:', error);
      });
  } catch (e) {
    console.error('[BuyNow] Erro ao parsear backup:', e);
    localStorage.removeItem('cartBackup');
    localStorage.removeItem('cartBackupTimestamp');
  }
}

// Restaura o carrinho quando a página carregar (se houver backup)
document.addEventListener("DOMContentLoaded", function () {
  // Só restaura se NÃO estiver na página de checkout
  if (!window.location.pathname.includes('/checkout')) {
    restoreCartFromLocalStorage();
  }
});

// Suporte para iOS Safari - pageshow é disparado quando volta do cache (back-forward cache)
window.addEventListener("pageshow", function (event) {
  // persisted = true significa que a página veio do cache (botão voltar)
  if (event.persisted) {
    console.log('[BuyNow] Página restaurada do cache (iOS), verificando carrinho...');
    if (!window.location.pathname.includes('/checkout')) {
      restoreCartFromLocalStorage();
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var buyNowButton = document.querySelector('[data-buy-now-button]');
  if (buyNowButton) {
    buyNowButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Encontra o formulário do produto
      var productForm = buyNowButton.closest('form[action*="/cart/add"]');
      if (!productForm) {
        productForm = document.querySelector('form[action*="/cart/add"]');
      }

      if (!productForm) {
        console.error('Formulário do produto não encontrado');
        return;
      }

      // Pega a quantidade selecionada
      var quantityInput = productForm.querySelector('[name="quantity"]');
      var quantity = quantityInput ? (parseInt(quantityInput.value) || 1) : 1;

      // ============================================================
      // VALIDAÇÃO DE LIMITES - APENAS PARA O PRODUTO DA PÁGINA
      // NÃO considera o carrinho, apenas a quantidade/peso deste produto
      // ============================================================

      // Verifica limite de quantidade (apenas do produto atual)
      if (quantity > CART_MAX_TOTAL_QUANTITY) {
        showCartLimitError(buyNowButton);
        return;
      }

      // Verifica limite de peso (apenas do produto atual)
      var productWeight = getProductWeightFromForm(productForm);
      var totalWeight = productWeight * quantity;

      if (totalWeight > CART_MAX_TOTAL_WEIGHT) {
        showCartWeightError(buyNowButton, 0, true, totalWeight);
        return;
      }

      // ============================================================

      // Desabilita o botão para evitar cliques múltiplos
      buyNowButton.disabled = true;
      var originalText = buyNowButton.textContent;
      buyNowButton.textContent = 'Processando...';

      // Pega o variant ID do produto atual
      var variantInput = productForm.querySelector('[name="id"]');
      var variantId = variantInput ? variantInput.value : null;

      if (!variantId) {
        console.error('Variant ID não encontrado');
        buyNowButton.disabled = false;
        buyNowButton.textContent = originalText;
        console.log('Erro ao identificar o produto. Por favor, tente novamente.');
        return;
      }

      // Salva o carrinho atual antes de redirecionar
      saveCartToLocalStorage().then(function () {
        // Constrói a URL do checkout usando cart permalink
        // Isso cria um checkout apenas com este item
        var checkoutUrl = '/cart/' + variantId + ':' + quantity;

        // Redireciona para o checkout
        window.location.href = checkoutUrl;
      });
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  var lastScrollTop = 0;
  var scrollThreshold = 100; // Aumentei o threshold para evitar mudanças muito sensíveis
  var currentDirection = null; // Variável para rastrear a direção atual

  function handleScroll() {
    var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var menuElements = document.querySelectorAll('[data-menu="scroll"]');

    if (menuElements.length === 0) return;

    // Só muda a direção se a diferença for significativa
    var scrollDifference = Math.abs(currentScrollTop - lastScrollTop);

    if (scrollDifference > scrollThreshold) {
      var newDirection = currentScrollTop > lastScrollTop ? 'down' : 'up';

      // Só aplica mudança se a direção realmente mudou
      if (newDirection !== currentDirection) {
        currentDirection = newDirection;

        menuElements.forEach(function (element) {
          if (currentDirection === 'down') {
            element.classList.remove('scrolled-up');
            element.classList.add('scrolled-down');
          } else {
            element.classList.remove('scrolled-down');
            element.classList.add('scrolled-up');
          }
        });
      }

      lastScrollTop = currentScrollTop;
    }
  }

  // Adiciona o listener de scroll com throttling para melhor performance
  var ticking = false;
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(function () {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Listener sempre ativo independentemente do tamanho de tela
  window.addEventListener('scroll', requestTick, { passive: true });

  // Executa uma vez no carregamento para definir o estado inicial
  handleScroll();
});


// Evento para remover a classe is-fixed quando clicar fora da barra de busca
document.addEventListener("DOMContentLoaded", function () {
  // Função para remover is-fixed e limpar estilos
  function removeIsFixed(searchBar, unfixButton) {
    searchBar.classList.remove('is-fixed');
    document.body.classList.remove('no-mobile-scroll');
    if (unfixButton) unfixButton.style.width = '';

    const results = searchBar.querySelector('.search-bar__results');
    if (results) results.setAttribute('aria-hidden', 'true');
  }

  // Função para inicializar a funcionalidade
  function initSearchBarFunctionality() {
    const searchBar = document.getElementById('header-search-bar');
    const toggleButton = document.querySelector('[data-action="toggle-search"]');
    const searchBg = document.querySelector('.header__search-background');
    const unfixButton = document.querySelector('[data-action="unfix-search"]');

    if (!searchBar || searchBar.hasAttribute('data-custom-initialized')) return;

    searchBar.setAttribute('data-custom-initialized', 'true');

    // Clique fora da barra de busca
    document.addEventListener('click', function (event) {
      if (!searchBar.contains(event.target) && (!toggleButton || (event.target !== toggleButton && !toggleButton.contains(event.target)))) {
        removeIsFixed(searchBar, unfixButton);
      }
    });

    // Previne propagação de cliques dentro da barra
    searchBar.addEventListener('click', event => event.stopPropagation());

    // Clique no fundo da barra
    if (searchBg && !searchBg.hasAttribute('data-custom-initialized')) {
      searchBg.setAttribute('data-custom-initialized', 'true');
      searchBg.addEventListener('click', function (event) {
        removeIsFixed(searchBar, unfixButton);
        event.stopPropagation();
      });
    }

    // Toggle mobile
    if (toggleButton && !toggleButton.hasAttribute('data-custom-initialized')) {
      toggleButton.setAttribute('data-custom-initialized', 'true');
      toggleButton.addEventListener('click', function (event) {
        event.preventDefault();

        const isVisible = searchBar.classList.contains('is-visible') || searchBar.style.display === 'block';

        if (isVisible) {
          searchBar.classList.remove('is-visible');
          searchBar.style.display = 'none';
          removeIsFixed(searchBar, unfixButton);
        } else {
          searchBar.classList.add('is-visible');
          searchBar.style.display = 'block';
          searchBar.classList.add('is-fixed');
          document.body.classList.add('no-mobile-scroll');

          const searchInput = searchBar.querySelector('.search-bar__input');
          if (searchInput) setTimeout(() => searchInput.focus(), 100);
        }
      });
    }
  }

  // Inicializações múltiplas para garantir carregamento
  [0, 100, 500].forEach(delay => setTimeout(initSearchBarFunctionality, delay));
  window.addEventListener('load', initSearchBarFunctionality);

  // Observer para mudanças no DOM
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(() => initSearchBarFunctionality())
      .observe(document.body, { childList: true, subtree: true });
  }
});

// Controle de quantidade limitada ao estoque disponível
document.addEventListener("DOMContentLoaded", function () {
  function initQuantityControl() {
    const quantitySelector = document.querySelector('.quantity-selector--product');
    if (!quantitySelector) return;

    const quantityInput = quantitySelector.querySelector('.quantity-selector__value');
    const increaseBtn = quantitySelector.querySelector('[data-action="increase-picker-quantity"]');
    const decreaseBtn = quantitySelector.querySelector('[data-action="decrease-picker-quantity"]');

    if (!quantityInput) return;

    // Marca como inicializado para evitar duplicação
    if (quantityInput.hasAttribute('data-quantity-control-initialized')) return;
    quantityInput.setAttribute('data-quantity-control-initialized', 'true');

    // Função para obter o limite máximo
    function getMaxQuantity() {
      const maxPerOrder = 30; // Limite máximo por pedido
      const maxAttr = quantityInput.getAttribute('max');

      if (!maxAttr || maxAttr === '') return maxPerOrder;

      const maxValue = parseInt(maxAttr);
      if (isNaN(maxValue)) return maxPerOrder;

      // Retorna o menor valor entre o estoque disponível e 50 unidades
      return Math.min(maxValue, maxPerOrder);
    }

    // Função para validar e ajustar a quantidade
    function validateQuantity() {
      const maxQuantity = getMaxQuantity();
      let currentValue = parseInt(quantityInput.value) || 1;

      // Garante que o valor está dentro dos limites
      if (currentValue < 1) currentValue = 1;
      if (currentValue > maxQuantity) {
        currentValue = maxQuantity;
        // Mostra feedback visual quando atingir o limite
        quantityInput.style.borderColor = '#ff0000';
        setTimeout(() => {
          quantityInput.style.borderColor = '';
        }, 500);
      }

      quantityInput.value = currentValue;

      // Atualiza o estado do botão de aumentar
      updateIncreaseButton(currentValue, maxQuantity);

      return currentValue;
    }

    // Função para atualizar o estado do botão de aumentar
    function updateIncreaseButton(currentValue, maxQuantity) {
      if (!increaseBtn) return;

      if (currentValue >= maxQuantity) {
        increaseBtn.setAttribute('disabled', 'disabled');
        increaseBtn.setAttribute('aria-label', 'Limite máximo atingido');
        increaseBtn.setAttribute('title', 'Limite máximo atingido (máx: ' + maxQuantity + ' unidades)');
        increaseBtn.style.opacity = '0.5';
        increaseBtn.style.cursor = 'not-allowed';
      } else {
        increaseBtn.removeAttribute('disabled');
        increaseBtn.style.opacity = '';
        increaseBtn.style.cursor = '';
        const originalLabel = increaseBtn.getAttribute('data-original-label');
        const originalTitle = increaseBtn.getAttribute('data-original-title');
        if (originalLabel) increaseBtn.setAttribute('aria-label', originalLabel);
        if (originalTitle) increaseBtn.setAttribute('title', originalTitle);
      }
    }

    // Salva os labels originais
    if (increaseBtn) {
      increaseBtn.setAttribute('data-original-label', increaseBtn.getAttribute('aria-label'));
      increaseBtn.setAttribute('data-original-title', increaseBtn.getAttribute('title'));
    }

    // Evento de aumentar quantidade
    if (increaseBtn) {
      // Remove listeners antigos se existirem
      const newIncreaseBtn = increaseBtn.cloneNode(true);
      increaseBtn.parentNode.replaceChild(newIncreaseBtn, increaseBtn);

      newIncreaseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const maxQuantity = getMaxQuantity();
        let currentValue = parseInt(quantityInput.value) || 1;

        // Só aumenta se estiver abaixo do limite
        if (currentValue < maxQuantity) {
          quantityInput.value = currentValue + 1;
          updateIncreaseButton(currentValue + 1, maxQuantity);
        } else {
          // Mostra feedback visual quando atingir o limite
          quantityInput.style.borderColor = '#ff0000';
          setTimeout(() => {
            quantityInput.style.borderColor = '';
          }, 500);
        }
      });
    }

    // Evento de diminuir quantidade
    if (decreaseBtn) {
      // Remove listeners antigos se existirem
      const newDecreaseBtn = decreaseBtn.cloneNode(true);
      decreaseBtn.parentNode.replaceChild(newDecreaseBtn, decreaseBtn);

      newDecreaseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let currentValue = parseInt(quantityInput.value) || 1;

        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
          updateIncreaseButton(currentValue - 1, getMaxQuantity());
        }
      });
    }

    // Previne entrada de caracteres não numéricos
    quantityInput.addEventListener('keydown', function (e) {
      // Permite: backspace, delete, tab, escape, enter
      if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Permite: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Permite: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return;
      }
      // Garante que é um número
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });

    // Valida quando o usuário digita manualmente ou cola
    quantityInput.addEventListener('input', function () {
      // Remove caracteres não numéricos
      let cleanValue = this.value.replace(/[^0-9]/g, '');

      // Se o valor limpo for diferente, atualiza
      if (cleanValue !== this.value) {
        this.value = cleanValue;
      }

      // Valida o valor em tempo real
      const maxQuantity = getMaxQuantity();
      let currentValue = parseInt(this.value) || 0;
      if (currentValue > maxQuantity) {
        this.value = maxQuantity;
        // Mostra feedback visual
        this.style.borderColor = '#ff0000';
        setTimeout(() => {
          this.style.borderColor = '';
        }, 500);
      }

      // Atualiza o botão de aumentar
      updateIncreaseButton(parseInt(this.value) || 1, maxQuantity);
    });

    quantityInput.addEventListener('change', function () {
      validateQuantity();
    });

    quantityInput.addEventListener('blur', function () {
      validateQuantity();
    });

    // Valida quando a variante muda
    document.addEventListener('variant:changed', function (event) {
      const variant = event.detail.variant;

      if (variant && variant.inventory_management && variant.inventory_policy === 'deny') {
        quantityInput.setAttribute('max', variant.inventory_quantity);
        quantityInput.setAttribute('data-inventory-quantity', variant.inventory_quantity);
      } else {
        quantityInput.removeAttribute('max');
        quantityInput.removeAttribute('data-inventory-quantity');
      }

      // Reseta para 1 e valida
      quantityInput.value = 1;
      validateQuantity();
    });

    // Validação inicial
    validateQuantity();
  }

  // Inicializa o controle de quantidade
  initQuantityControl();

  // Reinicializa quando o DOM muda (para temas dinâmicos)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          initQuantityControl();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});

// Controle de quantidade no carrinho (mini-cart e main-cart)
document.addEventListener("DOMContentLoaded", function () {
  const MAX_CART_TOTAL_QUANTITY = 30;
  const MAX_CART_TOTAL_WEIGHT = 25000; // 25kg em gramas

  function showFeedback(element) {
    if (!element) return;
    element.style.borderColor = '#ff0000';
    setTimeout(() => {
      element.style.borderColor = '';
    }, 500);
  }

  // Função para obter dados completos do carrinho (síncrona)
  function getCartData() {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js', false); // Síncrono
      xhr.send(null);
      if (xhr.status === 200) {
        return JSON.parse(xhr.responseText);
      }
    } catch (error) {
      console.error('Erro ao obter carrinho:', error);
    }
    return { item_count: 0, total_weight: 0, items: [] };
  }

  // Função para obter a quantidade total atual do carrinho (síncrona)
  function getCartTotalQuantity() {
    return getCartData().item_count || 0;
  }

  // Função para obter o peso total atual do carrinho (síncrona)
  function getCartTotalWeight() {
    return getCartData().total_weight || 0;
  }

  // Função para obter o peso de um item específico do carrinho
  function getItemWeight(lineItemElement) {
    // Tenta obter o peso do data attribute
    const weightAttr = lineItemElement.getAttribute('data-line-item-weight');
    if (weightAttr) {
      return parseFloat(weightAttr) || 0;
    }

    // Tenta obter o variant ID e buscar o peso do carrinho
    const variantIdAttr = lineItemElement.getAttribute('data-line-item-key') ||
      lineItemElement.getAttribute('data-variant-id');
    if (variantIdAttr) {
      const cartData = getCartData();
      const item = cartData.items?.find(i => i.key === variantIdAttr || i.variant_id == variantIdAttr);
      if (item) {
        return item.grams || 0;
      }
    }

    return 0;
  }

  // Função para mostrar mensagem de erro de quantidade
  function showCartLimitMessage() {
    console.log('[DEBUG showCartLimitMessage] Iniciando...');

    // Busca em mini-cart, main-cart ou geral
    let errorMessage = document.querySelector('#mini-cart .cart-limit-error-message');
    if (!errorMessage) {
      errorMessage = document.querySelector('.cart-wrapper .cart-limit-error-message');
      console.log('[DEBUG showCartLimitMessage] Tentou cart-wrapper:', errorMessage);
    }
    if (!errorMessage) {
      errorMessage = document.querySelector('.cart-limit-error-message');
      console.log('[DEBUG showCartLimitMessage] Fallback geral:', errorMessage);
    }

    console.log('[DEBUG showCartLimitMessage] Elemento final:', errorMessage);

    if (errorMessage) {
      // Atualiza o contador de itens na mensagem
      const cartData = getCartData();
      console.log('[DEBUG showCartLimitMessage] Cart data:', cartData);

      const countElement = errorMessage.querySelector('.cart-limit-count');
      if (countElement && cartData.item_count) {
        countElement.textContent = cartData.item_count;
        console.log('[DEBUG showCartLimitMessage] Contador atualizado:', cartData.item_count);
      }

      errorMessage.style.display = 'block';
      errorMessage.style.visibility = 'visible';
      errorMessage.style.opacity = '1';
      console.log('[DEBUG showCartLimitMessage] Mensagem exibida');

      setTimeout(() => {
        errorMessage.style.display = 'none';
        console.log('[DEBUG showCartLimitMessage] Mensagem escondida');
      }, 5000);
    } else {
      console.error('[DEBUG showCartLimitMessage] Elemento NOT FOUND! Verificar HTML.');
      // Mostra todos os elementos com classe parcial
      console.log('Elementos com "cart":', document.querySelectorAll('[class*="cart"]'));
    }
  }

  // Função para mostrar mensagem de erro de peso
  function showCartWeightMessage(remainingWeight = 0, isCartEmpty = false, weightAdicionado = 0) {
    let errorMessage = document.querySelector('.cart-weight-error-message');
    if (!errorMessage) {
      // Se não existir elemento específico de peso, usa o de limite
      errorMessage = document.querySelector('.cart-limit-error-message');
    }
    if (errorMessage) {
      if (isCartEmpty) {
        const weightAdicionadoKg = (weightAdicionado / 1000).toFixed(2).replace('.', ',');
        errorMessage.innerHTML = `O limite é 25kg e você adicionou ${weightAdicionadoKg}kg`;
      } else {
        // Caso 2: Carrinho já tem itens e a nova adição excede o limite
        const weightKg = (remainingWeight / 1000).toFixed(2).replace('.', ',');
        errorMessage.innerHTML = `O limite é 25kg, você pode adicionar mais ${weightKg}kg`;
      }

      errorMessage.style.display = 'block';
      setTimeout(() => {
        errorMessage.style.display = 'none';
      }, 5000);
    }
  }

  // Função para verificar e mostrar mensagem se o carrinho está no limite
  function checkAndShowCartLimitIfAtMax() {
    const cartData = getCartData();
    const currentTotal = cartData.item_count || 0;

    console.log('[DEBUG checkAndShowCartLimitIfAtMax] Total de itens:', currentTotal);

    // Se está no limite exato (30 itens), mostra a mensagem
    if (currentTotal >= MAX_CART_TOTAL_QUANTITY) {
      console.log('[DEBUG checkAndShowCartLimitIfAtMax] Carrinho no limite! Mostrando mensagem...');
      showCartLimitMessage();
    }
  }

  function initCartQuantityControl() {
    // Seleciona todos os quantity-selectors do carrinho (mini-cart e main-cart)
    const quantitySelectors = document.querySelectorAll('#mini-cart .quantity-selector, .line-item .quantity-selector');

    quantitySelectors.forEach(selector => {
      // Evita inicializar múltiplas vezes
      if (selector.hasAttribute('data-cart-quantity-initialized')) return;
      selector.setAttribute('data-cart-quantity-initialized', 'true');

      const quantityInput = selector.querySelector('.quantity-selector__value');
      const increaseBtn = selector.querySelector('[data-action="increase-quantity"]');
      const decreaseBtn = selector.querySelector('[data-action="decrease-quantity"]');

      if (!quantityInput) return;

      // Função para obter o limite máximo do item considerando o total do carrinho
      function getMaxQuantityForItem() {
        // Tenta obter o estoque do data-attribute ou do botão disabled
        const inventoryAttr = quantityInput.getAttribute('data-inventory-quantity');
        const maxAttr = quantityInput.getAttribute('max');

        let inventoryLimit = Infinity;
        if (inventoryAttr && inventoryAttr !== '') {
          inventoryLimit = parseInt(inventoryAttr);
        } else if (maxAttr && maxAttr !== '') {
          inventoryLimit = parseInt(maxAttr);
        }

        // Verifica se o botão de aumentar está desabilitado por estoque
        if (increaseBtn && increaseBtn.hasAttribute('disabled') && !increaseBtn.hasAttribute('data-disabled-by-cart-limit')) {
          const currentValue = parseInt(quantityInput.value) || 1;
          inventoryLimit = currentValue;
        }

        // Calcula o espaço disponível no carrinho
        const cartTotal = getCartTotalQuantity();
        const currentItemQuantity = parseInt(quantityInput.value) || 0;
        const otherItemsQuantity = cartTotal - currentItemQuantity;
        const spaceAvailable = MAX_CART_TOTAL_QUANTITY - otherItemsQuantity;

        // Retorna o menor entre estoque disponível e espaço no carrinho
        return Math.min(
          isNaN(inventoryLimit) ? MAX_CART_TOTAL_QUANTITY : inventoryLimit,
          spaceAvailable
        );
      }

      // Função para atualizar estado do botão de aumentar
      function updateIncreaseButton(currentValue, maxQuantity) {
        if (!increaseBtn) return;

        if (currentValue >= maxQuantity) {
          increaseBtn.setAttribute('disabled', 'disabled');
          increaseBtn.setAttribute('data-disabled-by-cart-limit', 'true');
          increaseBtn.style.opacity = '0.5';
          increaseBtn.style.cursor = 'not-allowed';
          increaseBtn.setAttribute('title', 'Limite máximo atingido (máx: ' + maxQuantity + ' unidades)');
        } else {
          // Só reabilita se originalmente não estava desabilitado por estoque
          const wasDisabledByStock = increaseBtn.hasAttribute('data-original-disabled');
          if (!wasDisabledByStock) {
            increaseBtn.removeAttribute('disabled');
            increaseBtn.removeAttribute('data-disabled-by-cart-limit');
            increaseBtn.style.opacity = '';
            increaseBtn.style.cursor = '';
            increaseBtn.setAttribute('title', 'Aumentar quantidade');
          }
        }
      }

      // Salva estado original do botão
      if (increaseBtn && increaseBtn.hasAttribute('disabled') && !increaseBtn.hasAttribute('data-disabled-by-cart-limit')) {
        increaseBtn.setAttribute('data-original-disabled', 'true');
      }

      // Intercepta clique no botão de aumentar
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function (e) {
          const currentValue = parseInt(quantityInput.value) || 1;
          const newQuantity = parseInt(this.getAttribute('data-quantity')) || (currentValue + 1);
          const quantityIncrease = newQuantity - currentValue;

          // Obtém dados do carrinho
          const cartData = getCartData();
          const cartTotal = cartData.item_count || 0;
          const cartWeight = cartData.total_weight || 0;

          // Verifica limite de quantidade
          if ((cartTotal + quantityIncrease) > MAX_CART_TOTAL_QUANTITY) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showFeedback(quantityInput);
            showCartLimitMessage();
            return false;
          }

          // Verifica limite de peso
          const lineItem = selector.closest('.line-item') || selector.closest('[data-line-item-key]');
          const itemWeight = lineItem ? getItemWeight(lineItem) : 0;
          const weightIncrease = itemWeight * quantityIncrease;

          if ((cartWeight + weightIncrease) > MAX_CART_TOTAL_WEIGHT) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showFeedback(quantityInput);
            const remainingWeight = Math.max(0, MAX_CART_TOTAL_WEIGHT - cartWeight);
            const isCartEmpty = cartWeight === 0;
            const updatedWeight = cartWeight + weightIncrease;
            showCartWeightMessage(remainingWeight, isCartEmpty, updatedWeight);
            return false;
          }

          const maxQuantity = getMaxQuantityForItem();
          if (newQuantity > maxQuantity) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showFeedback(quantityInput);
            return false;
          }
        }, true); // Usa capture para interceptar antes do handler do tema
      }

      // Salva o valor anterior quando o input recebe foco
      let previousValue = parseInt(quantityInput.value) || 1;

      quantityInput.addEventListener('focus', function () {
        previousValue = parseInt(this.value) || 1;
      });

      // Intercepta entrada manual no input
      quantityInput.addEventListener('input', function () {
        let cleanValue = this.value.replace(/[^0-9]/g, '');
        if (cleanValue !== this.value) {
          this.value = cleanValue;
        }

        const maxQuantity = getMaxQuantityForItem();
        let currentValue = parseInt(this.value) || 0;
        const difference = currentValue - previousValue;

        // Verifica limite de quantidade
        if (currentValue > maxQuantity) {
          this.value = previousValue; // Reverte para o valor anterior
          showFeedback(this);
          showCartLimitMessage();
          return;
        }

        // Verifica limite de peso
        const lineItem = selector.closest('.line-item') || selector.closest('[data-line-item-key]');
        const itemWeight = lineItem ? getItemWeight(lineItem) : 0;
        const cartData = getCartData();
        const weightIncrease = itemWeight * difference;

        if ((cartData.total_weight + weightIncrease) > MAX_CART_TOTAL_WEIGHT) {
          this.value = previousValue; // Reverte para o valor anterior
          showFeedback(this);
          const remainingWeight = Math.max(0, MAX_CART_TOTAL_WEIGHT - cartData.total_weight);
          const isCartEmpty = cartData.total_weight === 0;
          const updatedWeight = cartData.total_weight + weightIncrease;
          showCartWeightMessage(remainingWeight, isCartEmpty, updatedWeight);
          return;
        }

        updateIncreaseButton(parseInt(this.value) || 1, maxQuantity);
      });

      quantityInput.addEventListener('change', function () {
        const originalValue = previousValue;
        const cartData = getCartData();
        const cartTotal = cartData.item_count || 0;
        const cartWeight = cartData.total_weight || 0;
        let currentValue = parseInt(this.value) || 1;
        const difference = currentValue - originalValue;

        if (currentValue < 1) currentValue = 1;

        // Verifica se a nova quantidade ultrapassaria o limite do carrinho
        if ((cartTotal + difference) > MAX_CART_TOTAL_QUANTITY) {
          this.value = originalValue; // Reverte para o valor anterior
          showFeedback(this);
          showCartLimitMessage();
          return;
        }

        // Verifica se a nova quantidade ultrapassaria o limite de peso
        const lineItem = selector.closest('.line-item') || selector.closest('[data-line-item-key]');
        const itemWeight = lineItem ? getItemWeight(lineItem) : 0;
        const weightIncrease = itemWeight * difference;

        if ((cartWeight + weightIncrease) > MAX_CART_TOTAL_WEIGHT) {
          this.value = originalValue; // Reverte para o valor anterior
          showFeedback(this);
          const remainingWeight = Math.max(0, MAX_CART_TOTAL_WEIGHT - cartWeight);
          const isCartEmpty = cartWeight === 0;
          const updatedWeight = cartWeight + weightIncrease;
          showCartWeightMessage(remainingWeight, isCartEmpty, updatedWeight);
          return;
        }

        const maxQuantity = getMaxQuantityForItem();
        if (currentValue > maxQuantity) {
          currentValue = maxQuantity;
          showFeedback(this);
          showCartLimitMessage();
        }

        this.value = currentValue;
        previousValue = currentValue; // Atualiza o valor anterior
        updateIncreaseButton(currentValue, maxQuantity);
      });

      // Validação inicial
      const maxQuantity = getMaxQuantityForItem();
      const currentValue = parseInt(quantityInput.value) || 1;
      previousValue = currentValue;
      updateIncreaseButton(currentValue, maxQuantity);
    });
  }

  // Inicializa o controle
  initCartQuantityControl();

  // Verifica se o carrinho já está no limite ao carregar a página
  checkAndShowCartLimitIfAtMax();

  // Re-inicializa quando o DOM muda (carrinho atualizado via AJAX)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function (mutations) {
      let shouldReinit = false;
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (node.classList && (node.classList.contains('quantity-selector') ||
                node.closest && (node.closest('#mini-cart') || node.closest('.line-item')))) {
                shouldReinit = true;
              }
              if (node.querySelector && node.querySelector('.quantity-selector')) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      if (shouldReinit) {
        setTimeout(function () {
          initCartQuantityControl();
          checkAndShowCartLimitIfAtMax();
        }, 100);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Re-inicializa quando o carrinho é atualizado
  document.addEventListener('cart:refresh', function () {
    setTimeout(initCartQuantityControl, 200);
  });
});

// =============================================================================
// Scala Cart Button - Checkout com produto atual (ignorando carrinho)
// =============================================================================
// Este código detecta o botão scala-cart-button (que usa Shadow DOM) e redireciona
// o usuário para o checkout com apenas o produto da página atual.
// COMPATÍVEL COM iOS Safari (ES5)
// =============================================================================

document.addEventListener("DOMContentLoaded", function () {

  // Função para obter o variant ID do produto atual
  function getCurrentVariantId() {
    // Tenta pegar da URL primeiro
    var urlParams = new URLSearchParams(window.location.search);
    var variantFromUrl = urlParams.get('variant');
    if (variantFromUrl) return variantFromUrl;

    // Tenta pegar do input hidden do formulário
    var variantInput = document.querySelector('[action="/cart/add"] input[name="id"], form.product-form input[name="id"], .product-form input[name="id"]');
    if (variantInput && variantInput.value) return variantInput.value;

    // Tenta pegar do select de variantes
    var variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) return variantSelect.value;

    // Tenta pegar do data attribute
    var productForm = document.querySelector('[data-product-form]');
    if (productForm) {
      var selectedVariant = productForm.querySelector('[data-selected-variant]');
      if (selectedVariant) return selectedVariant.value;
    }

    return null;
  }

  // Função para obter a quantidade selecionada
  function getCurrentQuantity() {
    var quantityInput = document.querySelector('.quantity-selector--product .quantity-selector__value, input[name="quantity"]');
    if (quantityInput && quantityInput.value) {
      var qty = parseInt(quantityInput.value);
      return isNaN(qty) || qty < 1 ? 1 : qty;
    }
    return 1;
  }

  // Função para processar o clique no botão Scala
  // Fluxo: Limpa carrinho → Adiciona produto atual → Aplica desconto Scala → Redireciona
  function handleScalaButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var variantId = getCurrentVariantId();
    var quantity = getCurrentQuantity();

    if (!variantId) {
      console.error('[Scala Button] Variant ID não encontrado');
      console.log('Erro ao identificar o produto. Por favor, selecione uma variante.');
      return;
    }

    // ============================================================
    // VALIDAÇÃO DE LIMITES - REAPROVEITADO DO BUY NOW
    // ============================================================
    var scalaButtonElement = document.getElementById('scala-id:1');

    // Verifica limite de quantidade
    if (quantity > CART_MAX_TOTAL_QUANTITY) {
      showCartLimitError(scalaButtonElement);
      return;
    }

    // Busca o formulário do produto para calcular o peso
    var productForm = document.querySelector('form[action*="/cart/add"]');
    var productWeight = productForm ? getProductWeightFromForm(productForm) : 0;
    var totalWeight = productWeight * quantity;

    if (totalWeight > CART_MAX_TOTAL_WEIGHT) {
      // Como o fluxo limpa o carrinho, passamos remainingWeight=0 e isCartEmpty=true
      showCartWeightError(scalaButtonElement, 0, true, totalWeight);
      return;
    }
    // ============================================================

    console.log('[Scala Button] Iniciando checkout com produto:', variantId, 'quantidade:', quantity);

    // Salva o carrinho atual no localStorage antes de modificar
    var savePromise = typeof saveCartToLocalStorage === 'function'
      ? saveCartToLocalStorage()
      : Promise.resolve();

    savePromise.then(function () {
      // Passo 1: Limpa o carrinho completamente
      return fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        console.log('[Scala Button] Carrinho limpo');

        // Passo 2: Adiciona apenas o produto atual ao carrinho
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: quantity
            }]
          })
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        console.log('[Scala Button] Produto adicionado ao carrinho');

        // Passo 3: Aplica o atributo de desconto Scala (_scaladiscount: '1')
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              '_scaladiscount': '1'
            }
          })
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        console.log('[Scala Button] Desconto Scala aplicado, redirecionando para checkout');

        // Passo 4: Redireciona para o checkout
        window.location.href = '/checkout/';
      })
      .catch(function (error) {
        console.error('[Scala Button] Erro:', error);
        console.log('Erro ao processar. Por favor, tente novamente.');
      });
  }

  // Função para verificar se estamos na página de produto
  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  // Função para adicionar listener ao botão dentro do Shadow DOM
  // CONDIÇÃO: Apenas para o botão com id 'scala-id:1' e apenas em páginas de produto
  function attachScalaButtonListener(scalaButton) {
    // CONDIÇÃO 1: Verifica se é o botão correto (id = 'scala-id:1')
    if (scalaButton.id !== 'scala-id:1') {
      console.log('[Scala Button] Ignorando botão:', scalaButton.id, '- não é scala-id:1');
      return;
    }

    // CONDIÇÃO 2: Verifica se estamos na página de produto
    if (!isProductPage()) {
      console.log('[Scala Button] Ignorando - não estamos em página de produto');
      return;
    }

    // Verifica se já foi inicializado
    if (scalaButton.hasAttribute('data-scala-product-checkout-initialized')) return;
    scalaButton.setAttribute('data-scala-product-checkout-initialized', 'true');

    // Acessa o Shadow Root
    var shadowRoot = scalaButton.shadowRoot;
    if (!shadowRoot) {
      console.warn('[Scala Button] Shadow Root não encontrado');
      return;
    }

    // Encontra o botão dentro do Shadow DOM
    var innerButton = shadowRoot.getElementById('scala-button');
    if (!innerButton) {
      console.warn('[Scala Button] Botão interno não encontrado');
      return;
    }

    // Adiciona o listener de clique com capture para interceptar antes do handler original
    innerButton.addEventListener('click', handleScalaButtonClick, true);

    console.log('[Scala Button] Listener adicionado com sucesso para scala-id:1 na página de produto');
  }

  // Função para encontrar e processar todos os botões Scala
  function processScalaButtons() {
    // Só processa se estamos na página de produto
    if (!isProductPage()) return;

    // Procura especificamente pelo botão com id 'scala-id:1'
    var scalaButton = document.getElementById('scala-id:1');
    if (scalaButton && scalaButton.tagName === 'SCALA-CART-BUTTON') {
      if (scalaButton.shadowRoot) {
        attachScalaButtonListener(scalaButton);
      } else {
        // Tenta novamente após um pequeno delay
        setTimeout(function () {
          if (scalaButton.shadowRoot) {
            attachScalaButtonListener(scalaButton);
          }
        }, 100);
      }
    }
  }

  // Processa botões existentes
  processScalaButtons();

  // Observa mudanças no DOM para capturar botões criados dinamicamente
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var shouldProcess = false;

      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.nodeType === 1) {
              // Verifica se é um scala-cart-button ou contém um
              if (node.tagName === 'SCALA-CART-BUTTON' ||
                (node.querySelector && node.querySelector('scala-cart-button'))) {
                shouldProcess = true;
              }
            }
          }
        }
      });

      if (shouldProcess) {
        // Delay para garantir que o Shadow DOM foi criado
        setTimeout(processScalaButtons, 150);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Também processa quando o custom element é definido
  if (typeof customElements !== 'undefined' && customElements.whenDefined) {
    try {
      customElements.whenDefined('scala-cart-button').then(function () {
        setTimeout(processScalaButtons, 100);
      }).catch(function () {
        // Elemento pode já estar definido ou não existir
      });
    } catch (e) {
      // Fallback para browsers mais antigos
      console.log('[Scala Button] customElements.whenDefined não suportado');
    }
  }

  // Reprocessa após o carregamento completo da página
  window.addEventListener('load', function () {
    setTimeout(processScalaButtons, 500);
  });
});


// =============================================================================
// Scala Button — Visibilidade dinâmica
// =============================================================================
// Página de produto : mostra/oculta via data-pix-on no buy-now button (Liquid).
// Página do carrinho: ao remover qualquer item, recarrega a página.
//   → O Liquid re-renderiza o carrinho com os dados corretos do servidor
//     e o Scala button aparece/some automaticamente sem lógica JS extra.
// =============================================================================

(function () {

  // ── PÁGINA DE PRODUTO: visibilidade pelo data-pix-on ─────────────────────

  if (window.location.pathname.indexOf('/products/') !== -1) {

    var _timer = null;

    function applyProductVisibility() {
      _timer = null;
      var scala = document.getElementById('scala-id:1');
      if (!scala) return;
      var btn = document.querySelector('[data-buy-now-button]');
      if (!btn) return;
      var show = btn.hasAttribute('data-pix-on');
      scala.style.display = show ? '' : 'none';
      console.log('[Scala] produto show=' + show);
    }

    function scheduleProductCheck(delay) {
      if (_timer) clearTimeout(_timer);
      _timer = setTimeout(applyProductVisibility, delay || 300);
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        scheduleProductCheck(300);
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scheduleProductCheck(300); });
    } else {
      scheduleProductCheck(300);
    }
  }

  // ── PÁGINA DO CARRINHO: reload ao remover item ────────────────────────────

  if (window.location.pathname.indexOf('/cart') !== -1) {

    var removalPending = false;

    // Detecta clique em qualquer botão/link de remoção de item
    document.addEventListener('click', function (e) {
      var el = e.target;

      // Sobe na árvore DOM até encontrar o elemento de remoção
      while (el && el !== document.body) {
        var action = el.getAttribute && el.getAttribute('data-action');
        var quantity = el.getAttribute && el.getAttribute('data-quantity');

        // Botão de diminuir com quantity="0" = remoção
        if (action === 'decrease-quantity' && quantity === '0') {
          removalPending = true;
          break;
        }

        // Link "Remover" abaixo do seletor de quantidade
        if (el.classList && el.classList.contains('line-item__quantity-remove')) {
          removalPending = true;
          break;
        }

        el = el.parentElement;
      }
    }, true); // capture=true para interceptar antes do tema

    // Quando o tema termina o re-render AJAX do carrinho:
    // se foi uma remoção, recarrega para o Liquid re-renderizar tudo
    document.addEventListener('cart:rerendered', function () {
      if (removalPending) {
        removalPending = false;
        console.log('[Scala] Item removido → recarregando página');
        window.location.reload();
      }
    });
  }

})();
